import { FC, useMemo } from "react";

type Props = {
  percentage: number;
  backgroundColor: string;
  barColor: string;
};

const SimpleProgressBar: FC<Props> = ({
  backgroundColor,
  barColor,
  percentage,
}): JSX.Element => {
  const per = useMemo(() => percentage * 100, [percentage]);

  return (
    <div
      className="h-[2px]"
      style={{
        background: `linear-gradient(90deg, ${barColor} 0%, ${barColor} ${per}%, ${backgroundColor} ${per}%, ${backgroundColor} 100%)`,
      }}
    />
  );
};
export default SimpleProgressBar;
